import React, { useEffect, useState } from "react";
import { Card, Col, Dropdown, Row } from "react-bootstrap";
import search from "../../assets/search.svg";
import TopNavBar from "../Layout/TopNavBar";
import { Space, Table, Tag, Button } from "antd";
import CustomTable from "../Common/customeTable";
import { tableColumnOptionIcon } from "../Common/optionIcon";
import { showAlert, showError, showSuccess } from "../utills/sweetAlert";
import { callApi } from "../utills/api";
import { useNavigate } from "react-router-dom";
import { PlusOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import ReactPaginate from "react-paginate";

const Gallery = () => {
    const navigate = useNavigate();
    const [dashBoardDetails, setDashBoardDetails] = useState<any[]>([]);


    useEffect(() => {
        getDashboardData();
    }, []);

    const getDashboardData = () => {
        callApi("GET", "gallerySelect.php", "")
            .then((res) => res.data)
            .then((response) => {
                if (response) {
                    setDashBoardDetails(response.data);
                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState("");
    const handleSearch = (term: string) => {
        setSearchTerm(term);
    };

    const filteredData = dashBoardDetails.filter((item: any) =>
        Object.values(item).some((value) =>
            (value as string).toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    // Calculate pagination for filtered data
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    const offset = currentPage * itemsPerPage;
    const currentData = filteredData.slice(offset, offset + itemsPerPage);
    const handlePageClick = (event: { selected: number }) => {
        setCurrentPage(event.selected);
    };

    // Calculate the display range for the items
    const startItem = offset + 1;
    const endItem = Math.min(offset + itemsPerPage, filteredData.length);

    const addPage = () => {
        navigate('/layout/addgallery')
    }

    const editPage = (id: any,) => {
        console.log("masterId--->", id);
        navigate('/layout/addgallery', { state: { masterId: id } });

    }

    const deleteApi = async (id:any) => {
        const isComfirm = await showAlert(
            "Please Confirm",
            `Are you sure you want to Delete ?`,
            "Yes",
            "No"
        );
        if (isComfirm) {
            let req = {
                id: id,
            };
            callApi("POST", "galleryDelete.php", req)
                .then((res) => res.data)
                .then((response) => {
                    if (response) {
                        showSuccess("Success!", "Gallery Deleted Successfully!");

                        getDashboardData();
                    }
                })
                .catch((err: any) => {
                    console.error(
                        "API call error:",
                        err.response ? err.response.data.error : err.message
                    );
                    showError(
                        "Failed",
                        err.response ? err.response.data.error : err.message
                    );
                });
        }
    }

    const handleInactive = async (id: any, status: any) => {

        const action = status === "Active" ? "Inactivate" : "Activate";
        const isComfirm = await showAlert(
            "Please Confirm",
            `Are you sure you want to ${action}?`,
            "Yes",
            "No"
        );

        console.log("id-->",id);
        if (isComfirm) {
        const activeInactiveStatus = status === "Active" ? "Inactive" : "Active";
        let req = {
            id: id,
            status: activeInactiveStatus,
        };
        callApi("POST", "galleryStatusChange.php", req)
            .then((res) => res.data)
            .then((response) => {
                if (response) {
                    getDashboardData();

                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }
    }
    const data: any = dashBoardDetails ?? [];


    return (
        <>
            <div className="mobile_nav_bar">
                <TopNavBar />
            </div>
            <div className='mblcontent'>
                <Row className='webview'>
                    <div className="category-header">
                        <Col lg="7" md="7" >
                            <h3 className="category-title">
                                Gallery
                            </h3>
                        </Col>
                        <Col lg="5" md="5" className="headbtn " >
                            <button className="cashinbtn"
                                onClick={addPage}>
                                Add Photos
                            </button>
                            <div className="search-bar">
                                <img
                                    src={search}
                                    alt="search-icon"
                                    style={{ width: "22px" }}
                                />
                                <input type="text" placeholder="Search..."
                                    onChange={(e) => handleSearch(e.target.value)} />
                            </div>
                        </Col>
                    </div>
                </Row>
                <Row className='mblview mbldashboard'>
                    <div className="category-header">

                        <Col lg="8" md="8">
                            <h3 className="category-title">
                                Dashboard
                            </h3>
                        </Col>
                        <div className='mblcol'>

                        </div>
                        <Col lg="2" md="2">
                            <div className="search-bar">
                                <img
                                    src={search}
                                    alt="search-icon"
                                    style={{ width: "22px" }}
                                />
                                <input type="text" placeholder="Search..."
                                    onChange={(e) => handleSearch(e.target.value)} />
                            </div>
                        </Col>
                    </div>
                </Row>

                <div className="element-container">

                    {filteredData.length > 0 ? (
                        <div className="table-container">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Title</th>
                                        <th>Image</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>
                                            {offset + index + 1}
                                            </td>
                                            <td className='boldtd'>{item.title}</td>
                                            <td>
                                                <img 
                                                    src={item.attachements[0]?.url} 
                                                 alt="attachment" 
                                                 width="100" 
                                                 height="100" />
                                            </td>
                                            <td>
                                                {item.status == "Active" && (
                                                    <button
                                                    className='more-btn '
                                                        onClick={() => handleInactive(item.id, item.status)}
                                                    >
                                                        {item.status}
                                                    </button>
                                                )}
                                                {item.status == "Inactive" && (
                                                    <button
                                                    className='more-btn '
                                                    
                                                        onClick={() => handleInactive(item.id, item.status)}
                                                    >
                                                        {item.status}

                                                    </button>
                                                )}
                                            </td>

                                            <td>
                                                <div className='webview'>
                                                    <Dropdown align="end">
                                                        <Dropdown.Toggle
                                                            variant="link"
                                                            id="dropdown-basic"
                                                            style={{ border: "none", background: "transparent" }}
                                                        ></Dropdown.Toggle>
                                                        <Dropdown.Menu
                                                            id="webdropdown">
                                                            <Dropdown.Item
                                                                onClick={() => editPage(item.id)}
                                                            >
                                                                Edit
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                            onClick={() => deleteApi(item.id)}
                                                            >
                                                                Delete
                                                            </Dropdown.Item>

                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                                <div className='mblview'>
                                                    <Dropdown align="end">
                                                        <Dropdown.Toggle
                                                            variant="link"
                                                            id="dropdown-basic"
                                                            style={{ border: "none", background: "transparent" }}
                                                        ></Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                            // onClick={() => handleEdit(item.id)}
                                                            >
                                                                Edit
                                                            </Dropdown.Item>

                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="pagination-container">
                                <div className="pagination-info">
                                    {`${startItem} - ${endItem} of ${filteredData.length}`}
                                </div>
                                <ReactPaginate
                                    previousLabel={'<'}
                                    nextLabel={'>'}
                                    breakLabel={'...'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    activeClassName={'active-page'}
                                    pageClassName={'page-item'}
                                    previousClassName={'prev-next'}
                                    nextClassName={'prev-next'}
                                />
                            </div>
                        </div>
                    ) : (
                        <p className='nodata'>Data Not Found</p>
                    )}
                </div>
            </div>
        </>
    );
};

export default Gallery;